"use strict"
exports.__esModule = true;
exports.ChairIconConfig = {
  name: 'ChairIcon',
  height: 512,
  width: 448,
  svgPath: 'M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z',
  yOffset: 0,
  xOffset: 0,
};
exports.ChairIcon = require('../createIcon').createIcon(exports.ChairIconConfig);
exports["default"] = exports.ChairIcon;